import Vue from 'vue'
import VueI18n from 'vue-i18n'

import Dictionary from '@/dictionary'

import { LANG_FR, LANG_EN } from '@/consts/langs'
import { VUE_APP_I18N_FALLBACK_LOCALE, VUE_APP_LOKAL_ACTIVE, VUE_APP_LOKAL_APP_UNIQUEKEY, VUE_APP_LOKAL_EN_UNIQUEKEY, VUE_APP_LOKAL_FR_UNIQUEKEY, VUE_APP_ROOT_API } from '@/helpers/env'
import StatusHelper from '@/helpers/status'

import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import 'dayjs/locale/en'
import localizedFormat from 'dayjs/plugin/localizedFormat'

Vue.use(VueI18n)

const supportedLocales = [LANG_FR, LANG_EN]
let initialLocale = document.documentElement.lang
if (!supportedLocales.includes(initialLocale)) initialLocale = supportedLocales[0]

dayjs.extend(localizedFormat)

const instanceI18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: VUE_APP_I18N_FALLBACK_LOCALE || LANG_FR,
  messages: loadLocaleMessages()
})

setLang(initialLocale)

function loadLocaleMessages() {
  const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })

  return messages
}

async function loadDictionary() {
  const response = await fetch(`${VUE_APP_ROOT_API}/dictionaryapi/export`, {
    method: 'get',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })

  if (StatusHelper.isSuccess(response.status)) {
    Dictionary.state.dictionary = await response.json()
  }
}

function getNextSupportedLocale(locale) {
  let idx = supportedLocales.indexOf(locale)
  idx += 1

  if (idx >= supportedLocales.length) idx = 0

  return supportedLocales[idx]
}

function setLang(lang) {
  dayjs.locale(lang)
  instanceI18n.locale = lang

  document.documentElement.setAttribute('lang', lang)
}

const i18n = {
  instance: function() {
    return instanceI18n
  },
  locale: () => {
    return instanceI18n.locale
  },
  setLang,
  loadDictionary,
  changeLang: () => {
    const lang = getNextSupportedLocale(instanceI18n.locale)
    i18n.setLang(lang)
  },
  dayjs: date => {
    return dayjs(date)
  },
  isLangValid: lang => supportedLocales.includes(lang),
  t() {
    const item = Dictionary.state.dictionary.find(x => x.Key === arguments[0])
    if (item !== undefined) {
      return item.Values.find(x => x.Language === instanceI18n.locale).Value
    }

    return instanceI18n.t(...arguments)
  }
}

export default i18n
